import React from "react";
import Menu from "../Menu";
import Footer from "../footer";
import { Link } from "react-router-dom";
import MetaTags from "react-meta-tags";
import ReactGA from "react-ga";

export default function howGet() {
  return (
    <div>
      <MetaTags>
        <title>Как получить | Быстрый кредит онлайн в Украине ➣ Просто Гроші</title>
        <meta
          name="description"
          content="Как получить | Займы до 10000 грн онлайн на карту ⭐ наличными ✨ быстро ⏰ без отказа ✅ Просто Гроші"
        />
      </MetaTags>
      <Menu />
      <div className="main-block">
        <div className="main-block-info">
          <div className="main-block-info-left">
            <span className="howtotitle">Як отримати</span>
          </div>
          <div className="main-block-info-right">
            <h3>Для отримання кредиту потрібні:</h3>
            <ul>
              <li>оригінал паспорта та ІПН;</li>
              <li>постійний трудовий дохід;</li>
              <li>вік від 18 до 70 років.</li>
            </ul>
            <h3>Процес отримання кредиту:</h3>
            <ul>
              <li>Звертаєтеся до ПростоГрошi з оригіналом паспорта та кодом.</li>
              <li>За 10 хвилин заповнюємо заявку на отримання кредиту.</li>
              <li>Після 10 хвилин ухвалюється рішення про надання кредиту.</li>
              <li>При позитивному рішенні кредит видається готівкою у відділенні.</li>
              <li>При повторному зверненні кредит займає менше 5 хвилин.</li>
            </ul>
            <h3>Розмір та вартість кредиту:</h3>
            <ul>
              <li>ПростоГрошi при першому обігу видає кредити на суму до 20 000 грн.;</li>
              <li>
                сума процентів за користування кредитом залежить від розміру кредиту та строку користування;
              </li>
              <li>
                терміни користування кредитом можна продовжувати, за умови оплати відсотків за користування;
              </li>
              <li>при достроковому погашенні відсотки користування перераховуються.</li>
            </ul>
            <button>
              <Link to="/registration-step1-new2">Оформити заявку на отримання кредиту</Link>
            </button>
            <h3>Компанія ПростоГроші</h3>
            <p>
              ПростоГрошi – це спеціалізована фінансова компанія «Споживчий Центр». Ми зареєстровані Національною комісією, яка здійснює державне регулювання у сфері ринків фінансових послуг, свідоцтво про реєстрацію фінансової установи ІК №78. Єдиний вид діяльності компанії – видача кредитів. Наші реквізити: ТОВ «ПОТІБНИЧИЙ ЦЕНТР», ЕДРПОУ 37356833, 01032, м.Київ, вул.Саксаганського 133-А, тел.(044) 498 10 20, info@sgroshi.com. Ліцензію видано Нацкомфінпослуг, розпорядження від 28.02.2017р. №438.
            </p>
            <p>Процентная ставка</p>
            <p>
              Приклад розрахунку: при сумі кредиту 1000 грн., відсотки за користування коштами становитимуть 20 грн. на день, що становить приблизно 2% на день. APR – 730%. Жодних додаткових комісій та платежів за користування кредитом Компанія не стягує.
            </p>
          </div>
        </div>
      </div>
      <Footer />
      {ReactGA.pageview("/credit")}
    </div>
  );
}



// WEBPACK FOOTER //
// src/pages/howGet.js